import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import styles from '../styles/views/TermsOfService.module.scss';

const TermsOfService: React.FC = () => {
  const [termsContent, setTermsContent] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadTermsOfService = async () => {                
      try {
        const response = await fetch('/terms-of-service.md');
        if (!response.ok) {
          throw new Error('Failed to load Terms of Service');
        }
        const content = await response.text();
        setTermsContent(content);
      } catch (error) {
        console.error('Error loading Terms of Service:', error);
        setError('Failed to load Terms of Service');
      } finally {
        setIsLoading(false);
      }
    };

    loadTermsOfService();
  }, []);

  return (
    <div className={styles.termsContainer}>
      <div className={styles.termsHeader}>
        <h1 className={styles.termsTitle}>Terms of Service</h1>
        <p className={styles.termsSubtitle}>
          Review the terms and conditions governing the use of Liquid Credit services.
        </p>
      </div>

      <div className={styles.termsContent}>
        {isLoading ? (
          <div className={styles.loadingContainer}>
            <div className={styles.spinner}></div>
            <p>Loading Terms of Service...</p>
          </div>
        ) : error ? (
          <div className={styles.errorContainer}>
            <p>Error loading Terms of Service. Please try again later.</p>
          </div>
        ) : (
          <div className={styles.markdownContent}>
            <ReactMarkdown>
              {termsContent}
            </ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
};

export default TermsOfService;
